import React, { useEffect, useState } from "react";
import store from "../../redux/store";
import { Card, Flex, Heading, Spacer, Td, Text, Tr } from "@chakra-ui/react";
import TableView from "../../components/TableView";
import { useSelector } from "react-redux";
import CustomButton from "../../components/ButtonComp";
import ConfirmDialog from "../../components/ConfirmDialog";
import { toast } from "react-toastify";
import {
  get_all_inventory_list,
  get_inventory_list,
} from "../../redux/inventorySlice";
import { get_all_vendor_list } from "../../redux/vendorSlice";
import CustomSingleInput from "../../components/CustomSingleInput";
import Loader from "../../components/Loader";
import { baseUrl } from "../../utils/utils";
import { format } from "date-fns";

const PurchaseReports = () => {
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [rows, setRows] = useState(5);
  const [page, setpage] = useState(1);
  const [initialValue, setInitialValue] = useState(1);
  const [deleteId, setDeleteId] = useState(null);
  const [total_count, setTotal_count] = useState(0);
  const [salesType, setSalesType] = useState("");
  const [reports_list, setReports_list] = useState([]);
  const [loading, setLoading] = useState(false);
  const { all_inventory_list } = useSelector((state) => state.inventory);
  const { all_vendor_list } = useSelector((state) => state.vendors);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const today = new Date();
  const oneMonthAgo = new Date();
  oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
  const [startDate, setStartDate] = useState(format(oneMonthAgo, "yyyy-MM-dd"));
  const [endDate, setEndDate] = useState(format(today, "yyyy-MM-dd"));
  const [data, setData] = useState({});

  const vendor_list = all_vendor_list?.map((v) => ({
    label: v?.tradename,
    value: v?.id,
  }));

  const product_list = all_inventory_list?.map((v) => ({
    label: v?.product_name,
    value: v?.uuid,
  }));

  const handleDelete = async () => {
    setIsLoading(true);
    try {
      const formData = new FormData();
      formData.append("action", "delete");
      formData.append("id", deleteId);

      const response = await fetch(baseUrl + `inventory.php`, {
        method: "POST",
        body: formData,
      });

      const result = await response.json();
      if (result?.success) {
        store.dispatch(get_inventory_list({ page, rows }));
        toast.success(result?.message);
        setDeleteId(null);
        setDeleteDialog(false);
      } else {
        toast.error(result?.message);
      }
    } catch {
      toast.error("Failed to load product data");
    } finally {
      setIsLoading(false);
    }
  };

  const get_report_list = async () => {
    try {
      setLoading(true);
      const body = new FormData();

      body.append("action", salesType ? salesType : "list");
      body.append("page", page);
      body.append("limit", rows);
      body.append("fd", startDate);
      body.append("td", endDate);
      if (salesType === "product") {
        body.append("prod_code", selectedProduct);
      }
      if (salesType === "vendor") {
        body.append("vendor_id", selectedProduct);
      }

      const response = await fetch(`${baseUrl}reports/purchase_report.php`, {
        method: "POST",
        body,
      });

      const res = await response.json();
      if (res?.success) {
        setReports_list(res?.list);
        setTotal_count(res.totalcount);
      } else {
        setReports_list([]);
        setTotal_count(0);
      }
    } catch {
      console.log("Failed to fetch purchase report");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    get_report_list();
    store.dispatch(get_all_inventory_list());
    store.dispatch(get_all_vendor_list());
  }, []);

  return (
    <>
      <Card
        bg="#fff"
        py={3}
        px={5}
        flexDirection={["column", "row"]}
        alignItems={["flex-start", "center"]}
        gap={3}
        flexWrap="wrap"
      >
        <Heading w="full" fontSize="xl">
          Purchase Reports
        </Heading>
        <Spacer display={["none", "block"]} />
      </Card>

      <Card bg="#fff" py={3} px={5}>
        <Flex direction={["column", "row"]} wrap="wrap" gap={3} mb={3}>
          <CustomSingleInput
            width={["100%", "200px"]}
            label="Start Date"
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
          <CustomSingleInput
            width={["100%", "200px"]}
            label="End Date"
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
          <CustomSingleInput
            width={["100%", "200px"]}
            label="Select Type of Sales"
            placeholder="Select Type"
            select
            options={[
              { label: "Vendor", value: "vendor" },
              { label: "Product", value: "product" },
            ]}
            value={salesType}
            onChange={(e) => {
              setSalesType(e.target.value);
              setSelectedProduct(null);
            }}
          />
          {salesType && (
            <CustomSingleInput
              width={["100%", "200px"]}
              label={
                salesType === "vendor"
                  ? "Vendor Name"
                  : salesType === "product"
                  ? "Product Name"
                  : ""
              }
              placeholder="Select"
              select
              options={salesType === "product" ? product_list : vendor_list}
              value={selectedProduct}
              onChange={(e) => setSelectedProduct(e.target.value)}
            />
          )}
          <CustomButton
            title="Search"
            w={["100%", "auto"]}
            onClick={() => {
              setData({
                sd: startDate,
                ed: endDate,
                pcode: selectedProduct,
                ptype: salesType,
              });
              get_report_list();
            }}
          />
        </Flex>

        {data?.sd && (
          <Text>
            From Date: <b>{data.sd}</b> To Date: <b>{data.ed}</b> Sales Type:{" "}
            <b>
              {data.ptype === "product"
                ? "Product"
                : data.ptype === "vendor"
                ? "Vendor"
                : ""}
            </b>{" "}
            {data.ptype === "product"
              ? "Product Name"
              : data.ptype === "vendor"
              ? "Vendor Name"
              : ""}
            :{" "}
            <b>
              {data.ptype === "product"
                ? product_list?.find((v) => v.value === data.pcode)?.label
                : vendor_list?.find((v) => v.value === data.pcode)?.label}
            </b>
          </Text>
        )}
      </Card>

      {loading ? (
        <Card justify="center" align="center" p={5}>
          <Loader />
        </Card>
      ) : reports_list?.length === 0 ? (
        <Card justify="center" align="center" h={20}>
          <Text>No Data</Text>
        </Card>
      ) : (
        <Card>
          <TableView
            headData={[
              "S.No.",
              "INV No",
              "INV Date",
              "Product Name",
              "Type",
              "Quantity",
              "Empty Returned",
              "gst Amount",
              "taxable Amount",
              "Total Amount",
            ]}
            body={reports_list?.map((el, i) => (
              <Tr key={i}>
                <Td textAlign="center">{i + initialValue}</Td>
                <Td textAlign="center">{el.inv_no}</Td>
                <Td textAlign="center">{el.inv_date}</Td>
                <Td textAlign="center">{el.product_name}</Td>
                <Td textAlign="center">{el.type}</Td>
                <Td textAlign="center">{el.quantity}</Td>
                <Td textAlign="center">{el.empty_returned}</Td>
                <Td textAlign="center">{el.gst_amount}</Td>
                <Td textAlign="center">{el.taxable_amount}</Td>
                <Td textAlign="center">{el.total_amount}</Td>
              </Tr>
            ))}
            initialValue={initialValue}
            page={page}
            rows={rows}
            total_value={total_count}
            pagination
            onChange={(e) => {
              setInitialValue(1);
              setpage(1);
              store.dispatch(
                get_inventory_list({ page: 1, rows: e.target.value })
              );
              setRows(e.target.value);
            }}
            onPrevious={() => {
              if (page > 1) {
                setInitialValue(initialValue - rows);
                setpage(page - 1);
                store.dispatch(get_inventory_list({ page: page - 1, rows }));
              }
            }}
            onNext={() => {
              if (rows * page < total_count) {
                setInitialValue(initialValue + rows);
                setpage(page + 1);
                store.dispatch(get_inventory_list({ page: page + 1, rows }));
              }
            }}
          />
          <ConfirmDialog
            isOpen={deleteDialog}
            onClose={() => setDeleteDialog(false)}
            onConfirm={handleDelete}
            type="delete"
            title="Delete Inventory"
            message="Are you sure you want to delete this Inventory? This action cannot be undone and will remove all associated data."
            confirmText="Delete"
            cancelText="Cancel"
            isLoading={isLoading}
          />
        </Card>
      )}
    </>
  );
};

export default PurchaseReports;
